import 'react';
import 'react-dom';

/**
 * Polyfills and plugins for the browser.
 */
import 'svgxuse';
import 'lazysizes';
import 'picturefill';

/**
 * Components
 */
export * from './components';
export * from './modules';
export * from './templates';
